import { render } from "./SectionTitle.vue?vue&type=template&id=f55bdb16"
const script = {}

import exportComponent from "/Users/furkanyesil/Projects/fair-mieten-mg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__